import React from 'react';

import { AddVideoPanel } from '@bingads-webui-campaign-react/ads-studio-app-components';
import { notificationApi } from '../../adapters/get-notification';

export const AddVideoPanelPage = props => (
  <AddVideoPanel {...props} notificationApi={notificationApi} />
);
